import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useContentFetcher } from '@api/content.api';
import { useAccountStore } from '@stores/account.store';

export const useContentStore = defineStore('content', () => {
  const contentId = ref('');
  const contentFetcher = useContentFetcher();
  const accountStore = useAccountStore();

  const fetchContent = async (id: string) => {
    await contentFetcher.one.execute({ id }, accountStore.authToken);
  };

  const fetchContentList = async (collectionId?: string) => {
    await contentFetcher.list.execute({ collectionId }, accountStore.authToken);
  };

  return {
    contentId,

    content: contentFetcher.one.data,
    contentError: contentFetcher.one.error,
    isContentFetching: contentFetcher.one.isFetching,
    fetchContent,
    resetContent: contentFetcher.one.resetOne,

    contentList: contentFetcher.list.data,
    contentListError: contentFetcher.list.error,
    isContentListFetching: contentFetcher.list.isFetching,
    fetchContentList,
    resetContentList: contentFetcher.list.resetList,
  };
});
